module.exports = __webpack_public_path__ + "e84a237d7fe3b796fc539dc1ea1a4d95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/apple-icon-180x180.png
// module id = 2470
// module chunks = 85